
import { AiOutlineWarning, AiFillWarning, AiOutlineExclamationCircle, AiFillExclamationCircle } from 'react-icons/ai'
import { FaExclamation, FaExclamationCircle  } from 'react-icons/fa'
import { IconBaseProps } from 'react-icons/lib'
interface Props extends IconBaseProps {
    type: "information" | "warning" | "danger",
    outline: boolean
}

export const Icon = (props: Props) => {
    const {
        type,
        outline,
        ...rest
        } = props
    if (type === "warning") {
        if (outline)
            return <AiOutlineWarning {...rest} />
        return <AiFillWarning {...rest} />
    } else if (type === "information") {
        if (outline)
            return <FaExclamation {...rest} />
        return <FaExclamationCircle  {...rest} />
    }else if (type === "danger") {
        if (outline)
            return <AiOutlineExclamationCircle {...rest} />
        return <AiFillExclamationCircle {...rest} />
    }

}